<template>
  <NewBsBox
    ref="tr"
    :bs="{
      'cmp.table.thead': 'tr',
      ...bs,
    }"
    as="tr"
  >
    <slot />
  </NewBsBox>
</template>

<script>
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import { debounce } from 'lodash'

  export default {
    components: {
      NewBsBox,
    },
    props: {
      shouldClacHeight: Boolean, // column fixed table 需要计算每个单元格的高度
      bs: {
        type: Object,
        default: () => ({}),
      },
    },
    emits: ['theadTrHeightChange'],
    watch: {
      rowData: {
        immediate: true,
        handler() {
          if (!this.shouldClacHeight && !this.$refs.tr) {
            return
          }
          this.$nextTick(() => this.changeHeight())
        },
      },
    },
    mounted() {
      if (!this.shouldClacHeight) {
        return
      }
      window.addEventListener('resize', debounce(this.changeHeight, 300))
    },
    methods: {
      changeHeight() {
        this.$emit('theadTrHeightChange', this.$refs.tr.$el.offsetHeight)
      },
    },
  }
</script>
